import $ from "jquery";
import {post} from "./_ExtPractices/AjaxLogs";

module Auth {
    const ui = {
        name: $(".jLogin"),
        pass: $(".jPassword"),
        message: $(".jMessage"),
        send: $(".jSend")
    }

    function bind() {
        ui.send.on("click", async () => {
            ui.send.prop("disabled", true);
            const data = {
                name: ui.name.val(),
                password: ui.pass.val()
            }

            const res = await post<string>("/Auth/Login/", data);

            if (res.ok) {
                location.href = "/";
            } else {
                ui.message.text(res.data);
                ui.send.prop("disabled", false);
            }
        });
    }
    
    bind();

}